import { SET_CART, SET_CART_ITEMS_COUNT, SET_IS_LOADED } from '@common/Checkout/Shopcart/actions/constants';
import { CartState } from '@common/Checkout/Shopcart/types';
import { CartReducer } from '@common/Checkout/Shopcart/types/reducers';

const initialState: CartState = {
    id: 0,
    storeId: 0,
    totalBasePrice: '0',
    totalPrice: '0',
    baseItemsPrice: '0',
    itemsPrice: '0',
    discountValue: {
        value: '0',
        percentage: 0,
        priceBeforeDiscount: '0',
        priceAfterDiscount: '0',
    },
    voucherValue: {
        value: '0',
        percentage: 0,
        priceBeforeDiscount: '0',
        priceAfterDiscount: '0',
    },
    totalDiscount: {
        value: '0',
        percentage: 0,
        priceBeforeDiscount: '0',
        priceAfterDiscount: '0',
    },
    estimatedShippingPrice: '0',
    applicableOptInDiscount: 0,
    optInDiscountThresholdReached: false,
    optInDiscountQuantityThresholdReached: false,
    optInDiscountThresholdMessage: '',
    minValueThresholdReached: false,
    minThresholdReachedMessage: null,
    voucherOrderThreshold: null,
    itemsQuantity: 0,
    club: {
        hasClub: false,
        appliedBoozters: [],
        booztersDiscount: {
            amount: 0,
            currency: '',
            formatted: '0',
        },
        pointsForOrder: 0,
        pointsDescription: '',
    },
    reducedShippingPrice: {
        remaining: '0',
        percentage: 0,
        threshold: '0',
        message: '0',
    },
    currency: {
        code: '',
        sign: '',
        signPosition: 'after',
        thousandSeparator: '',
        decimalSeparator: '.',
    },
    splitOrder: null,
    config: { // not used
        minimumPurchaseAmount: 0,
        fewInStockQuantity: 0,
    },
    voucher: null,
    fees: [],
    items: [],
    trackingData: {
        screen_name: '',
        screen_type: '',
        items: [],
        quantity: 0,
        value: 0,
        currency: '',
        cart_id: 0,
    },
    giftCard: null,
    checkoutBanners: [],
    vatExcluded: false,
    prefillVoucher: null,
    prefillGiftCard: null,
    banners: [],
    prefixedId: '',
    shippingFee: '',
    shippingListTypes: [],
    shippings: [],
    xForYDiscount: null,
    paymentSummary: [],
    count: 0,
    isLoaded: false,
    isWalletVisible: false,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer: CartReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_CART_ITEMS_COUNT: {
            return {
                ...state,
                count: payload,
            };
        }

        case SET_CART: {
            return {
                ...state,
                ...payload,
            };
        }

        case SET_IS_LOADED: {
            return {
                ...state,
                isLoaded: payload,
            };
        }

        default:
            return state;
    }
};

export default reducer;
